import React from 'react'
import { View } from 'react-native'
import styled from 'styled-components/native'


export const RowWeb = styled(View)`
  flex-direction: ${props => (props.theme.isMobile ? 'column' : 'row')};
  flex-wrap: wrap;
`